import React from 'react';

import type { DividerNode } from './../../ricos-schema/next-schema';
import type { NodeViewRendererProps } from './../../ricos-types';

import { DividerViewer } from './divider-viewer';

const Divider = ({ node, nodeIndex, NodeViewContainer }: NodeViewRendererProps) => {
  return (
    <NodeViewContainer key={node.id} node={node} nodeIndex={nodeIndex}>
      <DividerViewer node={node as DividerNode} />
    </NodeViewContainer>
  );
};

export default Divider;
